import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-gray-300 relative overflow-hidden">
      {/* Background watermark */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-[0.03] pointer-events-none">
        <img 
          src="/AudioApex_icon_transparent.svg"
          alt=""
          className="w-96 h-96"
        />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img 
                src="/AudioApex_icon_transparent.svg"
                alt="Audio Apex"
                className="h-12 w-auto object-contain mb-2"
              />
              <img 
                src="/AudioApex_wordmark_transparent.svg"
                alt="Audio Apex"
                className="h-5 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              London's premier audio equipment rental service. Professional PA systems and Pequod Acoustics 
              for events from 20-2,000 guests across London and surrounding areas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold mb-4 heading-font">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Equipment
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Get Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold mb-4 heading-font">Our Services</h3>
            <ul className="space-y-2">
              <li className="text-sm text-gray-400">Last Minute Rentals</li>
              <li className="text-sm text-gray-400">Long Term Hire</li>
              <li className="text-sm text-gray-400">Pequod Acoustics Systems</li>
              <li className="text-sm text-gray-400">Professional DJ Equipment</li>
              <li className="text-sm text-gray-400">Delivery & Setup</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold mb-4 heading-font">Contact Us</h3>
            <ul className="space-y-2">
              <li className="flex items-start gap-2 text-sm text-gray-400">
                <MapPin className="w-4 h-4 mt-0.5 text-gray-500 flex-shrink-0" />
                <span>London & Surrounding Areas</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-400">
                <Phone className="w-4 h-4 mt-0.5 text-gray-500 flex-shrink-0" />
                <span>020 8049 5480</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-400">
                <Mail className="w-4 h-4 mt-0.5 text-gray-500 flex-shrink-0" />
                <span>info@audioapex.co.uk</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-400">
                <Clock className="w-4 h-4 mt-0.5 text-gray-500 flex-shrink-0" />
                <span>24/7 Emergency Hire Available</span>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-bold mb-4 heading-font">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Terms of Hire
                </Link>
              </li>
              <li>
                <Link to="/cookies" onClick={() => window.scrollTo(0, 0)} className="text-sm text-gray-400 hover:text-white transition-colors duration-200">
                  Cookie Notice
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} Audio Apex. All rights reserved.
            </p>
            <p className="text-xs text-gray-500">
              Serving London and the surrounding areas with premium audio solutions.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
